const route = {
	path: 'new',
	name: 'page-new-company',
	meta: {
		title: 'Nueva Compañía',
	},
	props: true,
	component: () => import('@/pages/companies/page-company-new'),
};

export default route;



// WEBPACK FOOTER //
// ./src/router/companies-new.js